<template>
  <div class="shopWrap">
    <div class="mb10">
      <shopHead @searchKey="searchKeyFn"></shopHead>
    </div>
    <!-- 交易记录搜索 -->
    <div class="Record w1000" v-if="isShowTab == 6">
      <el-form class="RecordForm " :inline="true" :model="formInline" label-position="right">
        <el-form-item label="日期：" label-width="100px">
          <el-date-picker v-model="formInline.TEtime" type="daterange" align="right" unlink-panels
            start-placeholder="时间" end-placeholder="时间" format="yyyy-MM-DD" value-format="yyyy-MM-DD">
            <template #range-separator>
              <div style="margin: 0 12px; width: 60px;display: flex;justify-content: space-between;align-items: center;">
                <img src="../../assets/imgs/shop/Calendar.png" alt="" width="30px">&nbsp;
                <span style="color:#5472F6;font-size: 18px;">到</span>
              </div>
            </template>
          </el-date-picker>
        </el-form-item>

        <el-form-item style="width: 100px;">
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="personMain w1000">
      <div class="perL">
        <loginBar></loginBar>
        <Nav></Nav>
      </div>
      <div class="perR">
        <!--个人仓库-->
        <div>
          <template v-if="isShowTab == 1">
            <ThreeInOne :type="type"></ThreeInOne>
          </template> <!-- 三合一页面 -->
          <template v-if="isShowTab == 2">
            <IntegralArea :type="type"></IntegralArea>
          </template> <!-- 积分专区 精品商城 -->
          <template v-if="isShowTab == 3">
            <BlackMarket></BlackMarket>
          </template> <!-- 黑市,竞拍,神秘黑市，限时-->
          <template v-if="isShowTab == 5">
            <BlackMarketDetail></BlackMarketDetail>
          </template> <!-- 黑市详情-->
          <template v-if="isShowTab == 4">
            <SearchResult :searchRes="searchRes"></SearchResult>
          </template> <!-- 搜索结果-->
          <template v-if="isShowTab == 6">
            <TransactionRecord></TransactionRecord>
          </template> <!-- 交易记录-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shopHead from './shopHead/shopHead'
import loginBar from '@/components/Login/login'
import Nav from '@/components/Nav/index'
import ThreeInOne from '@/views/shop/threeInOne/threeInOne'                   /* 三合一页面 */
import IntegralArea from '@/views/shop/integralArea'                          /* 精品商城 积分专区*/
import SearchResult from '@/views/shop/searchResult'                          /* 搜索结果页面 */
import TransactionRecord from '@/views/shop/transactionRecord'                //交易记录

import BlackMarket from '@/views/shop/blackMarket'                            /* 黑市 */
import BlackMarketDetail from '@/views/shop/blackMarket/detail'               /* 黑市详情 */

import eventBus from '@/common/bus.js'
import axios from "axios";
import Cookies from "js-cookie";
import { searchGoodsListApi } from "@/api/home/index.js";
export default {
  name: "index",
  components: {
    shopHead,
    loginBar,
    Nav,
    ThreeInOne,           // 三合一页面
    IntegralArea,         // 精品商店、积分专区
    SearchResult,
    BlackMarket,          // 黑市
    BlackMarketDetail,    // 黑市详情
    TransactionRecord,    //交易记录

  },
  data() {
    return {
      isShowTab: 1,
      type: '',            // 三合一页面类型
      isIntegerOrShop: '',
      searchRes: [],       // 搜索结果数据
      //交易记录搜索
      formInline: {
        TEtime: '',
      },
    }
  },
  created() {
  },
  methods: {
    async searchKeyFn(val) {
      await searchGoodsListApi({
        goodsName: val,
        order: {
          addTime: 0,
        },
        pageNum: 1,
        pageSize: 20
      })
        .then(res => {
          if (res.data.state == 200) {
            this.isShowTab = 4
            this.searchRes = {...res.data.data,goodsName:val}
          } else {
            this.$message.error(res.data.message)
          }
        })
    },

    onSubmit() {
      console.log(this.formInline)
    },

    routeChange(to, from) {                  // 路由参数切换
      if (to.query.type == 'hot' || to.query.type == 'supper') {    // 热卖，超值购
        this.isShowTab = 1
        this.type = to.query.type
      } else if (to.query.type == 'integralArea' || to.query.type == 'shoppingMall') {                  // 积分专区
        this.isShowTab = 2
        this.type = to.query.type
      } else if (to.query.type == 'blackMarket') {                   // 神秘黑市
        this.isShowTab = 3
      } else if (to.query.type == 'searchResult') {                  // 搜索结果
        this.isShowTab = 4
      } else if (to.query.type == 'blackMarketDetail') {
        this.isShowTab = 5
      } else if (to.query.type == 'transactionRecord') {
        this.isShowTab = 6
      } else {
        this.isShowTab = 1
      }
      document.documentElement.scrollTop = 0
    },
  },

  watch: {
    $route: {
      handler(to, from) {
        this.routeChange(to, from)
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  }
}
</script>

<style scoped lang="less">
.shopWrap {
  // background: url("../../assets/imgs/shop/bg1.png") no-repeat top center / 100% 500px;
}

.Record {
  border: 2px solid #5472F6;
  margin-bottom: 15px;

  .RecordForm {
    padding: 10px;
    display: flex;
    justify-content: center;
    /* 容器内内容靠右 */
  }

  .el-form-item {
    margin-bottom: 0px;

    /deep/.el-form-item__label {
      font-size: 20px;
      color: #5472F6;
    }

    /deep/.el-range-input {
      background-color: transparent;
      border: 2px solid #5472F6;
      width: 150px;
    }

    /deep/.el-form-item__content {
      width: 400px;
    }
  }

  /deep/.el-input__inner {
    background-color: #ffffff00;
    border: none;
  }
}

.personMain {
  display: flex;
  justify-content: space-between;

  .perL {
    width: 270px;
    // background: #fff;
  }

  .perR {
    width: 725px;
  }

}
</style>
